export default {

	computed: {

		// MÓDULOS
		_solicitacao(){
			return this._verificaModulo(1)
		},

		_notificacao(){
			return this._verificaModulo(10)
		},

		_hfdm(){
			return this._verificaModulo(5)
		},

		_adm_escolar(){
			return this._verificaModulo(9)
		},

		_ordem_missao(){
			return this._verificaModulo(2)
		},

		_manutencao(){
			return this._verificaModulo(6)
		},

		_monitoramento(){
			return this._verificaModulo(3)
		},

		_rastreamento(){
			return this._verificaModulo(4)
		},

		_administracao(){
			return this._verificaModulo(8)
		},

		_suporte(){
			return this._verificaModulo(19)
		},

		_relatorios(){
			return this._verificaModulo(7)
		},

		_diario_de_bordo(){
			return this._verificaModulo(11)
		},

		_diario_de_bordo_mecanico(){
			return this._verificaModulo(12)
		},

		_diario_de_bordo_operador(){
			return this._verificaModulo(17)
		},

		_prevencao_qualificada(){
			return this._verificaModulo(13)
		},

		_envio_de_mensagem(){
			return this._verificaModulo(14)
		},

		_despacho(){
			return this._verificaModulo(15)
		},

		_quadro_atividades(){
			return this._verificaModulo(16)
		},

		_contratos_sbh(){
			return this._verificaModulo(18)
		},

		_documentacao(){
			return this._verificaModulo(20)
		},

		_programacao_de_voo(){
			return this._verificaModulo(21)
		},

		_escala(){
			return this._verificaModulo(23)
		},
	},

	methods: {
		_verificaModulo(idModulo){
			return $cliente.getModulo(idModulo)
		},

		_getIdSistemaModulo(){
			return $cliente.getVersao('id_sistema')
		},
	}
}
